const navlinkJs = function () {

    $('.custom-drop-down').hover(function(e){
        $('.js--nav-overlay').addClass('submenu-menu-show');
        $('body').addClass('no--scroll');
    }, function(e){
        $('.js--nav-overlay').removeClass('submenu-menu-show');
        $('body').removeClass('no--scroll');
    });

    $('.js--site-header').hover(function(e){
        $('.js--site-header').addClass('submenu-menu-show');
    }, function(e){
        $('.js--site-header').removeClass('submenu-menu-show');
    });

}

export default navlinkJs;